import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=77ef705c&scoped=true&"
import script from "./TablePagination.vue?vue&type=script&lang=js&"
export * from "./TablePagination.vue?vue&type=script&lang=js&"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=77ef705c&prod&lang=scss&scoped=true&"
import style1 from "./TablePagination.vue?vue&type=style&index=1&id=77ef705c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef705c",
  null
  
)

export default component.exports